import { render } from "./Modal.vue?vue&type=template&id=a27a574a"
import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Partials/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a27a574a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a27a574a', __exports__)) {
    console.log('reload')
    api.reload('a27a574a', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=a27a574a", () => {
    console.log('re-render')
    api.rerender('a27a574a', render)
  })

}


export default __exports__